// 登录组件触发指令  ———李丁
import Vue from "vue"
import { getToken } from '@/utils/auth'
export default {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      getToken() ? binding.value() : Vue.prototype.$eventBus.$emit('goLogin', true)
    })
  },
}





